var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditTable',{attrs:{"label":"KODUKORD","items":_vm.regulations},on:{"createEvent":_vm.createRegulation,"updateEvent":_vm.updateRegulation,"deleteEvent":_vm.deleteRegulation}})
}
var staticRenderFns = []

export { render, staticRenderFns }